// Keep this allowlist shared by SDK configuration and the feedback entry point.
export function teacherPage(pathname) {
  return ({
    '/teachers.html': 'library',
    '/teachers/lesson.html': 'lesson',
    '/teachers/guide.html': 'guide',
  })[pathname] || null;
}
